
import { DatePipe } from '@angular/common';
import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { ActionDTO, DivisionDTO, MasterDataDTO, TaskDTO, TenderV2DTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { FormConfig } from '../../components/forms/form.objects';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { UserService } from '../../user.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Observable, forkJoin, of } from 'rxjs';
import {
  ActionDefinitionDTO,
  ActionResultDTO,
  AwardDTO,
  ProcurementProjectLotDTO,
  ProcurementProjectDTO,
  ValidationResultDTO,
  ValidationExecutionDTO,
  UnitPriceDTO, UnitPricesFilterDTO,
  ResultTypeDTO,
  LotBudgetDTO,
  ProjectBreakDownDTO,
  ProcurementProjectClassificationDTO,
  ContractModificationDTO
} from '../../api/plyca-dtos-v2';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { SelectItem } from 'primeng-lts/api';
import { AppConfiguration } from '../../conf/app.configuration';
import * as lodash from 'lodash';
import { PropertyService } from '../../properties/property.service';
import { DataRetrieverConfig, FieldConfig } from '../../api/contract-notice-dto';
import { ConfirmationService } from 'primeng-lts/api';
import { ServiceLocator } from './../../ServiceLocator';


@Component({
  selector: 'tender-UnitPrices',
  templateUrl: 'UnitPricesList.template.html',
  providers: [DatePipe, DialogService]
})



export class UnitPricesListComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loaded = false;
  editingMode = false;

  updateTenderFilter = false;

  elements: UnitPriceDTO[] = [];
  filteredElements: UnitPriceDTO[] = [];
  taxTypes: MasterDataDTO[];
  clonedElements: { [s: string]: UnitPriceDTO; } = {};

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;

  formConfig1: FormConfig;
  public filterModel: UnitPricesFilterDTO;

  windowHash: string;
  OptionsWindowHash: string;
  tender: TenderV2DTO;
  award: AwardDTO;
  contractModification: ContractModificationDTO;
  procurementprojectLot: ProcurementProjectLotDTO;
  procurementprojectAM: false;
  showLotes = false;
  lotes: any;
  public task: TaskDTO;
  readOnly = false;
  PRECIOSUNITARIOS_NUMDECIMALES = 2;
  // En el caso de Expedientes de Contratación que no son de Acuerdos Marco
  calculateTAX = false;


  queryFE = false;

  // Si la FI no tiene precios unitarios, consulta si la última FI aprovada tiene precios.
  // Si no los tiene, consulta la FADJ.
  queryLastFIApproved = false;
  queryFADJ = false;


  tmpID = -999;

  // Modal baja porcentual
  visibleOptions = false;
  selectedValue: string;
  globalPercentage = 0;
  selectedLot: any;
  lotsArray = [];
  lotPercentage = 0;
  selectedGroup: string;
  groupPercentage = 0;
  groupsArray = [];

  // Datos de la FE
  FEitems = [];

  lastPageFirstRecordIndex = 0;
  defaultNumberRows = 50;
  rowsPerPageOptions = [5, 10, 25, 50];

  // Gestion de Errores
  // datos modal validacion
  public showValidationInfo = true;
  public validationResult: ValidationResultDTO;
  public confirmationService: ConfirmationService;


  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    public translateService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    protected route: ActivatedRoute,
    protected appConfig: AppConfiguration,
    private propertyService: PropertyService,
    private changeDetectorRef: ChangeDetectorRef,

  ) {
    super();
    this.subscribe(
      this.propertyService.getProperty('PRECIOSUNITARIOS_NUMDECIMALES', '4')
        .pipe(
          tap(value => {
            this.PRECIOSUNITARIOS_NUMDECIMALES = Number(value);
          }),
          catchError((error: any) => {
            return of(undefined)
          })
        )
    );

    // hay que meter otro subscribe en medio
    this.subscribe(this.plycaService.getMasterDataValues('TIPO_IMPUESTO', undefined, undefined, 'expansionSet:COMPLETE').pipe(
      tap(
        (data) => {
          if (data && data.content) {
            // Se filtran los tipos a mostrar y se ordenan por el campo orden
            let filteredTaxTypes = data.content
              .filter((taxType) => (taxType.properties.ACTIVO === 1))
              .sort(
                (a, b) =>
                  a.properties.ORDEN < b.properties.ORDEN
                    ? -1
                    : a.properties.ORDEN > b.properties.ORDEN
                      ? 1
                      : 0
              );
            if (filteredTaxTypes && filteredTaxTypes.length > 0) {
              this.taxTypes = filteredTaxTypes;
            }

          }
          (error: any) => this.plycaErrorHandler.showServerError(error);
        }

      )));


    this.subscribe(this.helpService.showContextHelpObservable(HelpType.UNITPRICES_LIST));
    if (dialogConfig['context']) {
      this.readOnly = dialogConfig['context']['readonly'];
      this.task = dialogConfig?.data?.task;

      if (dialogConfig['context']['tender']) {
        this.tender = dialogConfig['context']['tender'];
        this.showLotes = this.tender['project'].breakdownLot.apportioned === true;
        if (this.showLotes) {

          this.lotes = this.tender.tenderLots.map((tl => { return tl.procurementProjectLot.lotId }));
          this.lotes = '' + this.lotes + '';

          this.tender.tenderLots.map((tl) => {
            return {
              label: tl.procurementProjectLot.lotNumber + '-' + tl.procurementProjectLot.description,
              value: tl.procurementProjectLot
            } as SelectItem;
          }).forEach((item: SelectItem) => {
            this.lotsArray.push(item);
          });
          this.selectedLot = this.lotsArray[0].value;

        } else {
          this.lotes = '0';

          this.lotsArray.push({
            //label: '#0',
            label: '0',
            value: { 'lotNumber': 0, 'lotId': 0 }
          } as SelectItem);
          this.selectedLot = this.lotsArray[0].value;


        }
        this.readOnly = dialogConfig['context']['readonly'];
        this.getFEGroups();
      } else if (dialogConfig['context']['award']) {
        this.award = dialogConfig['context']['award'];
        this.showLotes = this.award.division.project.breakdownLot.apportioned === true;
        if (this.showLotes) {
          this.lotes = this.award.awardsLots.map((tl => { return tl.projectLot.lotId }));
          this.lotsArray = this.award.awardsLots.map((tl => { return tl.projectLot }));
          this.lotes = '' + this.lotes + '';

          this.award.awardsLots.map((al) => {
            return {
              label: al.projectLot.lotNumber + '-' + al.projectLot.description,
              value: al.projectLot
            } as SelectItem;
          }).forEach((item: SelectItem) => this.lotsArray.push(item));

        } else {
          this.lotes = '0';
          this.lotsArray.push({
            //label: '#0',
            label: '0',
            value: { 'lotNumber': 0, 'lotId': 0 }
          } as SelectItem);
          this.selectedLot = this.lotsArray[0].value;
        }
      } else if (dialogConfig['context']['contractModification']) {
        this.contractModification = dialogConfig['context']['contractModification'];
        this.showLotes = this.contractModification?.procurementProjectInfo?.apportioned &&
          this.contractModification?.procurementProjectInfo?.apportioned === true;
        if (this.showLotes) {
          this.lotes = this.contractModification.contractModificationLot.projectLot.lotId;
          // this.lotsArray = this.contractModification.contractModificationLot.projectLot;
          this.lotes = '' + this.lotes + '';

          let itemLabel = this.contractModification.contractModificationLot.projectLot.lotNumber
            + '-' + this.contractModification.contractModificationLot.projectLot.description;
          let itemValue = this.contractModification.contractModificationLot.projectLot;

          let selectItem: SelectItem = { label: itemLabel, value: itemValue };
          this.lotsArray.push(selectItem);
          /*this.contractModification.projectLot.map((al) => {
            return {
              label: al.projectLot.lotNumber + '-' + al.projectLot.description,
              value: al.projectLot
            } as SelectItem;
          }).forEach((item: SelectItem) => this.lotsArray.push(item));*/
        } else {
          this.lotes = '0';
          this.lotsArray.push({
            //label: '#0',
            label: '0',
            value: { 'lotNumber': 0, 'lotId': 0 }
          } as SelectItem);
          this.selectedLot = this.lotsArray[0].value;
        }
      } else if (dialogConfig['context']['procurementprojectLot']) {

        // Establece el objeto ProcurementProjectLot
        this.setNewObjectProcurementProjectLotClean(dialogConfig['context']['procurementprojectLot']);

        //this.procurementprojectLot = dialogConfig['context']['procurementprojectLot'];
        this.procurementprojectAM = dialogConfig['context']['procurementprojectAM'];
        this.readOnly = dialogConfig['context']['readonly'];
        if (this.procurementprojectLot && !this.procurementprojectAM) {
          this.calculateTAX = true;
        }
        // Tiene lotes
        this.showLotes = this.procurementprojectLot.parent.breakdownLot.apportioned === true;
        if (this.showLotes) {
          this.lotes = '' + this.procurementprojectLot.lotId + '';
          //this.lotsArray = this.procurementprojectLot;
          this.lotsArray.push({
            label: this.procurementprojectLot.lotNumber + "-" + this.procurementprojectLot.description,
            //value: this.procurementprojectLot
            value: { 'lotNumber': this.procurementprojectLot.lotNumber, 'lotId': this.procurementprojectLot.lotId }
          } as SelectItem);

          this.selectedLot = this.lotsArray[0].value;


        } else {
          this.lotes = '0';
          this.lotsArray.push({
            //label: '#0',
            label: '0',
            value: { 'lotNumber': 0, 'lotId': 0 }
          } as SelectItem);
          this.selectedLot = this.lotsArray[0].value;
        }
      }

      this.dtoToModel();
    }
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);
  }

  reduceLot(lote: ProcurementProjectLotDTO) {
    // Se limpia el resto de datos para evitar referencias circulares
    let _reducedLot = new ProcurementProjectLotDTO();
    _reducedLot.identifier = lote.identifier;
    _reducedLot.lotNumber = lote.lotNumber;
    _reducedLot.lotId = lote.lotId;
    _reducedLot.description = lote.description;
    _reducedLot.budget = new LotBudgetDTO();
    return _reducedLot;
  }

  setNewObjectProcurementProjectLotClean(tmp: ProcurementProjectLotDTO) {
    // Se carga un nuevo objeto, pero limpio para no pese tanto
    this.procurementprojectLot = new ProcurementProjectLotDTO();
    this.procurementprojectLot.identifier = tmp.identifier;
    this.procurementprojectLot.lotNumber = tmp.lotNumber;
    this.procurementprojectLot.lotId = tmp.lotId;
    this.procurementprojectLot.description = tmp.description;


    // Se inicializa el array de Precios Unitarios
    let budget = new LotBudgetDTO();
    let unitPrice: Array<UnitPriceDTO> = [];
    budget.unitPrice = unitPrice;
    this.procurementprojectLot.budget = budget;
    // Se establece el parent
    let parent: ProcurementProjectDTO;
    parent = new ProcurementProjectDTO();
    // Identificador
    parent.identifier = tmp.parent.identifier;
    // Division
    /*let division = new DivisionDTO();
    division = tmp.parent.division;*/
    parent.division = tmp.parent.division;

    // Apportioned
    let breakdownLot: ProjectBreakDownDTO;
    breakdownLot = new ProjectBreakDownDTO;
    breakdownLot.apportioned = tmp.parent.breakdownLot.apportioned;
    parent.breakdownLot = breakdownLot;
    // Sistema Complementario
    parent.classification = tmp.parent.classification;
    // Fecha de Inicio
    parent.startDate = tmp.parent.startDate;
    // ExpedienteID
    parent.contractFolderId = tmp.parent.contractFolderId;
    // Titulo Abreviado
    parent.abbreviatedTitle = tmp.parent.abbreviatedTitle;

    this.procurementprojectLot.parent = parent;
  }


  ngOnInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.OptionsWindowHash = generateRandomIdentifier();
    this.showValidation();

  }



  dtoToModel() {


    this.filterModel = new UnitPricesFilterDTO();


    this.filterModel['ui'] = {};

    this.filterModel['ui']['isTender'] = this.tender !== undefined;

    this.filterModel['ui']['isAward'] = this.award !== undefined;

    this.filterModel['ui']['isProcurementProjectLot'] = this.procurementprojectLot !== undefined;

    this.filterModel['ui']['isProcurementProjectLotAM'] = this.procurementprojectAM !== undefined && this.procurementprojectAM;

    this.filterModel['ui']['isContractModification'] = this.contractModification !== undefined;

    this.filterModel.filterListaLotes = this.lotsArray.map(lote => lote.value);
    this.filterModel.filterSelectedLot = this.lotsArray[0].value;

    this.initializeFormConfig();
  }



  private createFormConfig1(): Observable<FormConfig> {

    return of(new FormConfig(undefined,
      'unitPrices/UnitPricesFilterISettings.json',
      this.filterModel
    ));
  }

  ngAfterContentInit(): void {



    if (this.tender || this.award || this.procurementprojectLot || this.contractModification) {

      let obj;
      let type;
      let identifier;
      if (this.tender) {
        obj = this.tender;
        identifier = this.tender.identifier;
        type = 'TENDER';
      } else if (this.award) {
        obj = this.award;
        identifier = this.award.identifier;
        type = 'AWARD';
      } else if (this.procurementprojectLot) {
        obj = this.procurementprojectLot;
        identifier = this.procurementprojectLot.identifier;
        type = 'PROCUREMENTPROJECTLOT';
      } else if (this.contractModification) {
        obj = this.contractModification;
        identifier = this.contractModification.identifier;
        type = 'CONTRACTMODIFICATION';
      }
      this.subscribe(
        forkJoin([
          this.plycaService
            .getAvailableAction('EXPORT_UNITPRICE_TO_EXCEL',
              identifier,
              type),
          this.plycaService
            .getAvailableAction('IMPORT_UNITPRICE_FROM_EXCEL',
              identifier,
              type),
          this.plycaService
            .getAvailableAction('SAVE_UNITPRICES',
              identifier,
              type)
        ]).pipe(
          map(
            (prop: any[]) => {
              if (prop[0] && prop[0].actions) {
                prop[0].actions.forEach(action => {
                  this.subscribe(this.headerActionsService.addWindowAction(
                    action.name,
                    action.icon,
                    'btn-secondary',
                    true,
                    this.windowHash,
                    () => this.enabledHeaderButtons()
                  ), success => {

                    this.executeExportAction(obj);

                  });
                })
              }
              if (prop[1] && prop[1].actions) {
                prop[1].actions.forEach(action => {
                  this.subscribe(this.headerActionsService.addWindowAction(
                    action.name,
                    action.icon,
                    'btn-secondary',
                    true,
                    this.windowHash,
                    () => !this.readOnly && this.enabledHeaderButtons()
                  ), success => {
                    this.executeImportAction(obj);
                  });
                })
              }
              if (prop[2] && prop[2].actions) {
                prop[2].actions.forEach(action => {
                  this.subscribe(this.headerActionsService.addWindowAction(
                    action.name,
                    action.icon,
                    'btn-secondary',
                    true,
                    this.windowHash,
                    () => !this.readOnly && this.enabledHeaderButtons()
                  ), success => {
                    this.executeSaveAction(obj);
                  });
                })
              }

            }),
          catchError((error) => {
            this.plycaErrorHandler.showServerError(error);
            return of(error);
          }),
          finalize(() => {
            this.generalActions();
            // this.waitService.cancelWaiting(); // Al finalizar (ok o con error)  se cancela la capa de espera.
          })
        )

      )

    }


    this.loadData();
  }

  public executeExportAction(obj: any) {
    if (this.elements && this.elements.length > 0) {
      this.export(obj);
    } else {
      this.uiService.showMessage(
        'No es posible realizar la exportación de "Precios Unitarios", sino se ha introducido al menos un registro en la tabla asociada',
        'Información'
      );
    }
  }

  export(obj: any) {
    this.subscribe(this.plycaService.getAction('EXPORT_UNITPRICE_TO_EXCEL'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];
        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;
          action.parameters = action.parameters.filter(
            (param) => param.name !== 'TARGET'
          );

          let tmp: any;
          if (this.tender) {
            tmp = lodash.cloneDeep(this.tender);

            if (this.tender.tenderLots.length > 1) {
              const filteredLots = this.tender.tenderLots.filter(
                lot => lot.procurementProjectLot?.lotId === this.selectedLot.lotId
              );

              if (filteredLots.length > 0) {
                tmp.tenderLots = filteredLots;
              }
            }

            tmp.unitPrice = this.elements;
            tmp = JSON.parse(
              JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
            );
            action.target = tmp;
          } else if (this.award) {
            tmp = lodash.cloneDeep(this.award);
            tmp.unitPrice = this.elements;
            tmp = JSON.parse(
              JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
            );
            action.target = tmp;
          } else if (this.contractModification) {
            tmp = lodash.cloneDeep(this.contractModification);
            tmp.budget.unitPrice = this.elements;
            tmp = JSON.parse(
              JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
            );
            action.target = tmp;
          } else if (this.procurementprojectLot) {
            tmp = lodash.cloneDeep(this.procurementprojectLot);
            //console.log('antes de limpiar', this.procurementprojectLot, tmp);
            /*tmp.parent = this.viewModel2DTO(tmp.parent);
            tmp.parent.breakdownLot.lots = null;
            tmp.parent.breakdownLot.totalLots = null;*/
            tmp.budget.unitPrice = this.elements;
            tmp = JSON.parse(
              JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
            );
            action.target = tmp;
            action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.lot.ProcurementProjectLotDTO';
          }


          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = actionDefinition.executableAction.target;
          config['runAction'] = true;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(ref.onClose, (result: any) => {

            if (result && result.length) {
              console.log(result);
            }

          });
        }
      }
    });
  }



  executeSaveAction(obj: any) {
    if (this.editingMode) {
      // Si estamos editando no guardamos.
      this.uiService.showMessage('Confirme la edición de todos los registros antes de guardar los precios unitarios.',
        this.translateService.instant('General.error'));
    } else {

      this.uiService.showConfirmMessage(
        {
          message: 'Al guardar eliminará los registros existentes en la tabla de precios unitarios y añadirá los registros actuales',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.subscribe(this.plycaService.getAction('SAVE_UNITPRICES'), (datos: any) => {
              if (datos && datos.content) {
                let actionDefinition: ActionDefinitionDTO = datos.content[0];
                if (actionDefinition && actionDefinition.executableAction) {
                  let action = actionDefinition.executableAction;
                  action.parameters = action.parameters.filter(
                    (param) => param.name !== 'TARGET'
                  );

                  let tmp: any;
                  if (this.tender) {
                    tmp = lodash.cloneDeep(this.tender);

                    if (this.tender.tenderLots.length > 1) {
                      const filteredLots = this.tender.tenderLots.filter(
                        lot => lot.procurementProjectLot?.lotId === this.selectedLot.lotId
                      );

                      if (filteredLots.length > 0) {
                        tmp.tenderLots = filteredLots;
                      }
                    }

                  } else if (this.award) {
                    tmp = lodash.cloneDeep(this.award);
                  } else if (this.contractModification) {
                    tmp = lodash.cloneDeep(this.contractModification);
                  } else if (this.procurementprojectLot) {
                    //this.procurementprojectLot.budget.unitPrice = [];
                    tmp = lodash.cloneDeep(this.procurementprojectLot);
                  }

                  let parentDoc = {};

                  if (this.tender) {
                    parentDoc = this.tender;
                    tmp.unitPrice = lodash.cloneDeep(this.elements);
                    tmp.validationResult = undefined;
                  } else if (this.award) {
                    parentDoc = this.award;
                    tmp.unitPrice = lodash.cloneDeep(this.elements);
                  } else if (this.contractModification) {
                    parentDoc = this.contractModification;
                    tmp.budget.unitPrice = lodash.cloneDeep(this.elements);
                  } else if (this.procurementprojectLot) {
                    parentDoc = this.procurementprojectLot;
                    tmp.budget.unitPrice = lodash.cloneDeep(this.elements);
                    // Solo en el caso de la FE de Contratación
                    if (!this.procurementprojectAM) {
                      tmp.budget.manualTaxCalculation = this.calculateTAX;
                    }
                  }

                  if (!this.procurementprojectLot && !this.contractModification) {
                    tmp.unitPrice = tmp.unitPrice.map(up => {
                      if (tmp.unitPrice.identifier < -99) { up.identifier = undefined }
                      if (this.award) { up.tenderingPrice = undefined; up.lowPercentage = undefined }
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    tmp.unitPrice = tmp.unitPrice.map(up => {
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    tmp = JSON.parse(
                      JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                    );
                    action.target = tmp;
                  } else if (this.contractModification) {
                    tmp.budget.unitPrice = tmp.budget.unitPrice.map(up => {
                      if (tmp.budget.unitPrice.identifier < -99) { up.identifier = undefined }
                      up.tenderingPrice = undefined;
                      up.lowPercentage = undefined;
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    tmp.budget.unitPrice = tmp.budget.unitPrice.map(up => {
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    tmp = JSON.parse(
                      JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                    );
                    action.target = tmp;
                  } else {
                    // Si es el objeto lote
                    tmp.budget.unitPrice = tmp.budget.unitPrice.map(up => {
                      if (tmp.budget.unitPrice.identifier < -99) { up.identifier = undefined }
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    tmp.budget.unitPrice = tmp.budget.unitPrice.map(up => {
                      up['parentDoc'] = parentDoc;
                      return up;
                    });
                    // Despues se limpia el padre
                    /*tmp.parent = this.viewModel2DTO(tmp.parent);
                    tmp.parent.breakdownLot.lots = null;
                    tmp.parent.breakdownLot.totalLots = null;
                    // Primero se limpia el lote
                    tmp = JSON.parse(
                      JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                    );*/


                    //tmp = lodash.cloneDeep(this.procurementprojectLot);
                    tmp.parent = this.viewModel2DTO(tmp.parent);
                    tmp.parent.breakdownLot.lots = null;
                    tmp.parent.breakdownLot.totalLots = null;

                    tmp = JSON.parse(
                      JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                    );
                    tmp.validationResult = undefined;

                    action.target = tmp;
                    action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.lot.ProcurementProjectLotDTO';
                  }

                  let config: DynamicDialogConfig = {
                    header: actionDefinition.executableAction.name,
                    width: '70%',
                    styleClass: 'actionStyle',
                  };
                  config['action'] = action;
                  config['dto'] = actionDefinition.executableAction.target;
                  config['runAction'] = true;

                  this.waitService.startWaiting();
                  this.subscribe(
                    this.plycaService.runActionUsingPUT(action, this.parameters2string(action, actionDefinition.executableAction.target))
                      .pipe(
                        tap((result: ActionResultDTO) => {

                          console.log('Acción ejecutada: ', result);
                          if (result.identifier === 'OK') {

                            this.uiService.showSuccess(
                              this.translateService.instant('Actions.exec.ok'),
                              this.translateService.instant('General.info'),
                              'success'
                            );


                          } else {
                            let message = this.translateService.instant('General.errorMessage');
                            if (result.description) {
                              message = result.description;
                            }
                            this.uiService.showContent(message, 'Error', 'errorStyle');
                          }
                        }),
                        catchError(
                          (err) => {

                            this.plycaErrorHandler.showServerError(err);
                            this.waitService.cancelWaiting();
                            this.ref.close();
                            return of(err);
                          }),

                        finalize(() => {

                          this.waitService.cancelWaiting();
                        })
                      )
                  );



                }
              }
            });
          }
        });
    }
  }

  public viewModel2DTO(parentLot: ProcurementProjectDTO): ProcurementProjectDTO {
    // trabajamos con una copia del objeto
    let tmpExp: ProcurementProjectDTO;
    tmpExp = lodash.cloneDeep(parentLot);
    console.log('antes de limpiar', parentLot, tmpExp);
    tmpExp.validationResult = undefined;
    // limpiar variables de apoyo de tablas
    tmpExp = JSON.parse(
      JSON.stringify(tmpExp, (k, v) => (k === '_parent' ? undefined : v))
    );
    return tmpExp;
  }

  public printStringLengths(objeto: any) {
    for (const key in objeto) {
      if (typeof objeto[key] === 'string') {
        console.log(`${key}: ${objeto[key].length}`);
      } else if (typeof objeto[key] === 'object') {
        this.printStringLengths(objeto[key]);
      }
    }
  }


  executeImportAction(obj: any) {

    let confirmMessage = '';
    // Se inicializa a cero la pagina
    if (this.elements && this.elements.length > 0) {
      confirmMessage = 'REEMPLAZAR eliminará los registros existentes en la tabla de precios unitarios y añadirá los registros del archivo Excel que seleccione a continuación';
    } else {
      confirmMessage = 'AÑADIR cargará los registros del archivo Excel seleccionado';
    }
    this.uiService.showConfirmMessage(
      {
        message: confirmMessage,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.lastPageFirstRecordIndex = 0;
          this.subscribe(this.plycaService.getAction('IMPORT_UNITPRICE_FROM_EXCEL'), (datos: any) => {
            if (datos && datos.content) {
              let actionDefinition: ActionDefinitionDTO = datos.content[0];
              if (actionDefinition && actionDefinition.executableAction) {
                let action = actionDefinition.executableAction;
                action.parameters = action.parameters.filter(
                  (param) => param.name !== 'TARGET'
                );

                let tmp: any;
                if (this.tender) {
                  tmp = lodash.cloneDeep(this.tender);
                  if (this.tender.tenderLots.length > 1) {
                    const filteredLots = this.tender.tenderLots.filter(
                      lot => lot.procurementProjectLot?.lotId === this.selectedLot.lotId
                    );

                    if (filteredLots.length > 0) {
                      tmp.tenderLots = filteredLots;
                    }
                  }

                  tmp.unitPrice = this.elements;
                  tmp = JSON.parse(
                    JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                  );
                  action.target = tmp;
                } else if (this.award) {
                  tmp = lodash.cloneDeep(this.award);
                  tmp.unitPrice = this.elements;
                  tmp = JSON.parse(
                    JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                  );
                  action.target = tmp;
                } else if (this.contractModification) {
                  tmp = lodash.cloneDeep(this.contractModification);
                  tmp.budget.unitPrice = this.elements;
                  tmp = JSON.parse(
                    JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                  );
                  action.target = tmp;
                } else if (this.procurementprojectLot) {
                  // Se limpian las referencias circulares del objeto
                  tmp = lodash.cloneDeep(this.procurementprojectLot);
                  //console.log('antes de limpiar', this.procurementprojectLot, tmp);
                  /*tmp.parent = this.viewModel2DTO(tmp.parent);
                  tmp.parent.breakdownLot.lots = null;
                  tmp.parent.breakdownLot.totalLots = null;*/
                  tmp.budget.unitPrice = this.elements;

                  tmp = JSON.parse(
                    JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
                  );
                  action.target = tmp;
                  action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.lot.ProcurementProjectLotDTO';
                }


                let config: DynamicDialogConfig = {
                  header: actionDefinition.executableAction.name,
                  width: '70%',
                  styleClass: 'actionStyle',
                };
                config['action'] = action;
                config['dto'] = actionDefinition.executableAction.target;
                config['runAction'] = true;

                const ref = this.dialogService.open(ActionsProcessComponent, config);
                this.subscribe(ref.onClose, (result: any) => {

                  if (result && result.length) {

                    let list = result.map(up => {
                      up.identifier = this.tmpID;
                      this.tmpID--;
                      return up
                    });
                    this.elements.splice(0);
                    this.elements.push(...list);
                    this.elements.forEach(
                      (up: UnitPriceDTO) =>
                        up['lotsArray'] = this.lotsArray);
                    this.clearFilter();
                    this.tmpID = 0;
                    this.filteredElements = [].concat(this.elements);

                  } else {
                    this.clearFilter();
                    this.tmpID = 0;
                    this.elements = [];
                    this.filteredElements = [];
                  }

                });
              }
            }
          });
        }
      });
  }
  generalActions() {


    /*if (this.procurementprojectLot) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'Verificar',
        'fas fa-lg fas fa-check',
        'btn-secondary',
        true, this.windowHash
      ), success => {
        this.verify();
      });
    }*/


    if (this.tender || this.contractModification) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'Recargar precios unitarios',
        'fas fa-undo',
        'btn-secondary',
        true, this.windowHash,
        () => !this.readOnly && this.enabledHeaderButtons()
      ), success => {

        this.uiService.showConfirmMessage(
          {
            message: this.tender ?
              'Al recargar la tabla, se recuperarán de nuevo los precios unitarios de la ficha expediente. ¿Desea continuar?' :
              'Al recargar la tabla, se recuperarán de nuevo los últimos precios unitarios aprovados. ¿Desea continuar?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              if (this.tender) {
                this.updateTenderFilter = true;
                this.queryFE = true;
                this.loadDataPreviousDocument();
              } else if (this.contractModification) {
                this.queryLastFIApproved = true;
                this.loadDataPreviousDocument();
              }
            }
          });
      });
    }

    if (this.tender || this.procurementprojectLot || this.contractModification) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.add',
        'fas fa-plus',
        'btn-primary',
        true, this.windowHash,
        () => !this.readOnly && this.enabledHeaderButtons()
      ), success => {
        this.add();
      });
    }

    // percentage reduction
    if (this.tender) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'Baja porcentual',
        'fas fa-percentage',
        'btn-secondary',
        true,
        this.windowHash,
        () => !this.readOnly && this.enabledHeaderButtons()
      ), success => {
        this.percentageReductionAction();
      });
    }
    if (this.tender || this.procurementprojectLot) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.accept',
        'fas fa-check',
        'btn-primary',
        true,
        this.OptionsWindowHash,
        () => !this.readOnly && this.enabledHeaderButtons()
      ), success => {

        this.visibleOptions = false;

      });
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.cancel',
        'fas fa-times',
        'btn-secondary',
        true, this.OptionsWindowHash,
        !this.readOnly
      ), success => {
        this.selectedValue = undefined;
        this.selectedGroup = undefined;
        this.selectedLot = this.lotsArray[0].value;
        this.lotPercentage = 0;
        this.groupPercentage = 0;
        this.globalPercentage = 0;
        this.visibleOptions = false;

      });
    }

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {

      this.ref.close();
    });
  }
  percentageReductionAction() {


    this.uiService.showConfirmMessage(
      {
        message: this.translateService.instant('La baja porcentual se aplica SIEMPRE sobre los precios unitarios de licitación incluidos en la Ficha de Expediente. Si se hubiesen realizado previamente modificaciones en la tabla de precios de la pantalla de ofertas, estas no se tendrán en cuenta para el cálculo de la baja porcentual. ¿Desea continuar? '),
        acceptLabel: this.translateService.instant('General.yes'),
        rejectLabel: this.translateService.instant('General.no'),
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.visibleOptions = true;
        }
      });


  }
  public onShowOptions() {

    this.selectedValue = undefined;
    this.selectedGroup = undefined;
    this.selectedLot = this.lotsArray[0].value;
    this.lotPercentage = 0;
    this.groupPercentage = 0;
    this.globalPercentage = 0;

  }
  public onCloseOptions() {
    console.log(this.selectedValue);
    let msg = '';

    switch (this.selectedValue) {
      case 'global': {
        msg = 'Al introducir el porcentaje a la baja se recuperarán los precios unitarios de la ficha de expediente y se aplicará el porcentaje sobre ellos, ¿Desea continuar?';
        break;
      }
      case 'grupo': {
        msg = 'Al introducir el porcentaje a la baja se recuperarán los precios unitarios de la ficha de expediente para el grupo '
          + this.selectedGroup + ' y se aplicará el porcentaje sobre ellos, ¿Desea continuar?';
        break;
      }
      case 'lote': {
        msg = 'Al introducir el porcentaje a la baja se recuperarán los precios unitarios de la ficha de expediente para el lote '
          + this.selectedLot.lotNumber + ' y se aplicará el porcentaje sobre ellos, ¿Desea continuar?';
        break;
      }
    }

    if (msg) {
      this.uiService.showConfirmMessage(
        {
          message: msg,
          acceptLabel: this.translateService.instant('General.yes'),
          rejectLabel: this.translateService.instant('General.no'),
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            switch (this.selectedValue) {
              case 'global': {
                this.elements = [];
                let tmp = lodash.cloneDeep(this.FEitems);
                tmp.map(i => {
                  i.amountExcludingTaxes = this.calculatePercentage(i.tenderingPrice, this.globalPercentage);
                  i.lowPercentage = this.globalPercentage;

                  return i
                }
                ).forEach((item: any) => {
                  this.elements.push(item);
                });
                this.elements.sort(
                  (a, b) => {
                    // Sort by group
                    // If the first item has a higher number, move it down
                    // If the first item has a lower number, move it up

                    if (a.group > b.group) { return 1; }
                    if (a.group < b.group) { return -1; }
                    // If the group  is the same between both items, sort identifier
                    // If the first item identifier comes first in the alphabet, move it up
                    // Otherwise move it down
                    if (a.identifier > b.identifier) { return 1; }
                    if (a.identifier < b.identifier) { return -1; }

                  }



                );
                this.filteredElements = [].concat(this.elements);
                break;
              }
              case 'grupo': {
                let tmpFE = lodash.cloneDeep(this.FEitems);
                let tmp = [];
                this.elements.filter(g => g.group !== this.selectedGroup
                ).forEach((item: any) => {
                  tmp.push(item);
                });

                tmpFE.filter(g => g.group === this.selectedGroup).map(i => {
                  i.amountExcludingTaxes = this.calculatePercentage(i.tenderingPrice, this.groupPercentage);
                  i.lowPercentage = this.groupPercentage * 1;
                  return i
                }
                ).forEach((item: any) => {
                  tmp.push(item);
                });
                this.elements = [].concat(tmp);
                this.elements.sort(
                  (a, b) => {
                    // Sort by group
                    // If the first item has a higher number, move it down
                    // If the first item has a lower number, move it up

                    if (a.group > b.group) { return 1; }
                    if (a.group < b.group) { return -1; }
                    // If the group  is the same between both items, sort identifier
                    // If the first item identifier comes first in the alphabet, move it up
                    // Otherwise move it down
                    if (a.identifier > b.identifier) { return 1; }
                    if (a.identifier < b.identifier) { return -1; }

                  }



                );
                this.filteredElements = [].concat(this.elements);
                break;
              }
              case 'lote': {
                this.elements = [];
                let tmp = lodash.cloneDeep(this.FEitems);
                tmp.map(i => {
                  if (i.lot.lotNumber === this.selectedLot.lotNumber) {
                    i.amountExcludingTaxes = this.calculatePercentage(i.tenderingPrice, this.lotPercentage);
                    i.lowPercentage = this.lotPercentage;
                  }

                  return i
                }
                ).forEach((item: any) => {
                  this.elements.push(item);
                });
                this.elements.sort(
                  (a, b) => {
                    // Sort by group
                    // If the first item has a higher number, move it down
                    // If the first item has a lower number, move it up

                    if (a.group > b.group) { return 1; }
                    if (a.group < b.group) { return -1; }
                    // If the group  is the same between both items, sort identifier
                    // If the first item identifier comes first in the alphabet, move it up
                    // Otherwise move it down
                    if (a.identifier > b.identifier) { return 1; }
                    if (a.identifier < b.identifier) { return -1; }

                  }



                );
                this.filteredElements = [].concat(this.elements);
                break;
              }
            }
          }
        });
    }



    // Error msg ='Los precios unitarios no tienen correctamente definido el tipo de IVA,
    // por lo que no es posible aplicar la baja porcentual'
  }
  add() {
    this.clearFilter();
    let up = new UnitPriceDTO();
    up.identifier = this.tmpID;
    up.lot = this.lotsArray[0].value;
    this.tmpID--;
    up['lotsArray'] = this.lotsArray;
    this.elements.push(up);
    this.filteredElements = [].concat(this.elements);
    // Es necesario que se vaya a la ultima fila de la tabla
    this.gotoLastPage(true);
    console.log('this.lastPageFirstRecordIndex*************** ' + this.lastPageFirstRecordIndex);
    // Se deberia poner en modo edición la fila
    /*let row = 0;
    if (this.elements && this.elements.length > 0) {
      row = this.elements.length - 1;
    }
    this.onRowEditInit(up, row);*/
  }

  onPageChange(event: any) {
    this.lastPageFirstRecordIndex = event.first;
    this.defaultNumberRows = event.rows;
  }

  gotoLastPage(gotoLastPage: boolean) {
    if (gotoLastPage) {
      // Accede al número total de registros de la tabla

      let totalRecords = this.elements?.length;
      // Establece el primer índice para la última página

      const totalPages = Math.ceil(totalRecords / this.defaultNumberRows);
      this.lastPageFirstRecordIndex = (totalPages) * this.defaultNumberRows;

    }
  }


  save() {


    let params;


    // Se consulta por la entidad correspondiente
    if (this.tender) {
      params = {
        'parentDoc.division.project.identifier': this.tender.division.project.identifier,
        'parentDoc.documentClass.identifier': this.tender.documentClass.identifier,
        'parentDoc.orderNumber': this.tender.orderNumber + '',
        'lot.lotId': this.lotes
      }
    } else if (this.award) {
      params = {
        'parentDoc.division.project.identifier': this.award.division.project.identifier,
        'parentDoc.division.identifier.id': this._getSimpleIdentifierFromString(this.award.division.identifier),
        'parentDoc.documentClass.identifier': this.award.documentClass.identifier,
        'parentDoc.orderNumber': this.award.orderNumber,
        'lot.lotId': this.lotes
      }
    } else if (this.contractModification) {
      params = {
        'parentDoc.division.project.identifier': this.contractModification.division.project.identifier,
        'parentDoc.division.identifier.id': this._getSimpleIdentifierFromString(this.contractModification.division.identifier),
        'parentDoc.documentClass.identifier': this.contractModification.division.documentClass.identifier,
        'parentDoc.orderNumber': this.contractModification.orderNumber,
        'lot.lotId': this.lotes
      }
    } else if (this.procurementprojectLot) {
      params = {
        'parentDoc.division.project.identifier': this.procurementprojectLot.parent.identifier,
        'parentDoc.documentClass.identifier': '00002',
        'parentDoc.orderNumber': 0 + '',
        'lot.lotId': this.lotes
      }
    }

    this.subscribe(
      this.plycaService.insert<any>(
        this.configuration.UNITPRICES_SERVICE_URL, params
      ).pipe(
        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      results => {
        if (results && results.content) {
          this.elements = results.content;
        } else {
          this.elements = [];
        }
        this.loaded = true;
      },
      error => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error)
      });
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }



  public clearFilter(): void {
    this.filterModel.code = '';
    this.filterModel.description = '';
    this.filterModel.group = '';
    this.updateFilter(this.elements);
  }




  loadData() {
    this.waitService.startWaiting();
    this.loaded = false;
    let params;
    let executeService = true;

    // Se consulta por la entidad correspondiente
    if (this.queryFE) {
      let apportionned = this.tender['project'].breakdownLot.apportioned === true;
      if (!apportionned || (apportionned && this.tender.tenderLots !== undefined && !(this.tender.tenderLots.length > 1))) {
        params = {
          'parentDoc.division.project.identifier': this.tender.division.project.identifier,
          'parentDoc.documentClass.identifier': '00002',
          'parentDoc.orderNumber': 0 + '',
          'lot.lotId': this.lotes
        }
      } else {
        // Hay mas de un lote
        params = {
          'parentDoc.division.project.identifier': this.tender.division.project.identifier,
          'parentDoc.documentClass.identifier': '00002',
          'parentDoc.orderNumber': 0 + '',
          'lot.lotId': this.filterModel.filterSelectedLot.lotId
        }
      }
    } else if (this.tender) {
      let apportionned = this.tender['project'].breakdownLot.apportioned === true;
      // No hay lotes, o solo hay un lote
      if (!apportionned || (apportionned && this.tender.tenderLots !== undefined && !(this.tender.tenderLots.length > 1))) {
        params = {
          'parentDoc.division.project.identifier': this.tender.division.project.identifier,
          'parentDoc.documentClass.identifier': this.tender.documentClass.identifier,
          'parentDoc.orderNumber': this.tender.orderNumber + '',
          'lot.lotId': this.lotes
        }
      } else if (this.filterModel.filterSelectedLot !== undefined && this.filterModel.filterSelectedLot !== null) {
        //Hay mas de un lote
        params = {
          'parentDoc.division.project.identifier': this.tender.division.project.identifier,
          'parentDoc.documentClass.identifier': this.tender.documentClass.identifier,
          'parentDoc.orderNumber': this.tender.orderNumber + '',
          'lot.lotId': this.filterModel.filterSelectedLot.lotId
        }
      } else {
        // No se ha seleccionado nada en el filtro.
        this.filteredElements = [];
        this.elements = [];
        executeService = false;
        this.loaded = true;
        this.waitService.cancelWaiting();
      }

    } else if (this.award) {
      params = { // Traer datos de la oferta SIEMPRE
        'parentDoc.division.project.identifier': this.award.tender.division.project.identifier,
        'parentDoc.documentClass.identifier': this.award.tender.documentClass.identifier,
        'parentDoc.orderNumber': this.award.tender.orderNumber + '',
        'lot.lotId': this.lotes
        /*
        'parentDoc.division.project.identifier': this.award.division.project.identifier,
        'parentDoc.division.identifier.id': this._getSimpleIdentifierFromString(this.award.division.identifier),
        'parentDoc.documentClass.identifier': this.award.documentClass.identifier,
        'parentDoc.orderNumber': this.award.orderNumber,
        'lot.lotId': this.lotes*/
      }
    } else if (this.contractModification) {
      params = { // Traer datos de la oferta SIEMPRE
        'parentDoc.division.identifier': this.contractModification.division.identifier,
        'parentDoc.documentClass.identifier': this.contractModification.documentClass.identifier,
        'parentDoc.orderNumber': this.contractModification.orderNumber,
        'lot.lotId': this.lotes
      }
    } else if (this.procurementprojectLot) {
      params = {
        'parentDoc.division.project.identifier': this.procurementprojectLot.parent.identifier,
        'parentDoc.documentClass.identifier': '00002',
        'parentDoc.orderNumber': 0 + '',
        'lot.lotId': this.lotes
      }
    }

    if (executeService) {
      this.subscribe(
        this.plycaService.query<any>(
          this.configuration.UNITPRICES_SERVICE_URL, params
        ).pipe(
          finalize(() => this.handleFinalize())
        ),
        results => {
          if (results && results.content) {
            if (this.tender) {
              this.queryFE = false;
            }
            if (this.contractModification) {
              this.queryLastFIApproved = false;
              this.queryFADJ = false;
            }

            this.elements = results.content.sort(
              (a, b) => {
                // Sort by group
                // If the first item has a higher number, move it down
                // If the first item has a lower number, move it up

                if (a.group > b.group) { return 1; }
                if (a.group < b.group) { return -1; }
                // If the group  is the same between both items, sort identifier
                // If the first item identifier comes first in the alphabet, move it up
                // Otherwise move it down
                if (a.identifier > b.identifier) { return 1; }
                if (a.identifier < b.identifier) { return -1; }

              }



            );
            this.elements.forEach(
              (up: UnitPriceDTO) =>
                up['lotsArray'] = this.lotsArray);
          } else {
            if (this.tender) { this.queryFE = true; }
            if (this.contractModification) { this.queryLastFIApproved = true; }
            this.loadDataPreviousDocument();

          }
          this.filteredElements = [].concat(this.elements);
          this.loaded = true;
        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error)
        });

    }
  }

  loadDataPreviousDocument() {
    if (this.queryFE || this.queryFADJ || this.queryLastFIApproved) {
      this.waitService.startWaiting();
      this.loaded = false;
      let params;

      let url = this.configuration.UNITPRICES_SERVICE_URL
      // Se consulta por la entidad correspondiente
      if (this.queryFE) {
        let apportionned = this.tender['project'].breakdownLot.apportioned === true;
        if (!apportionned || (apportionned && this.tender.tenderLots !== undefined && !(this.tender.tenderLots.length > 1))) {
          params = {
            'parentDoc.division.project.identifier': this.tender.division.project.identifier,
            'parentDoc.documentClass.identifier': '00002',
            'parentDoc.orderNumber': 0 + '',
            'lot.lotId': this.lotes
          }
        } else {
          // Hay mas de un lote
          params = {
            'parentDoc.division.project.identifier': this.tender.division.project.identifier,
            'parentDoc.documentClass.identifier': '00002',
            'parentDoc.orderNumber': 0 + '',
            'lot.lotId': this.filterModel.filterSelectedLot.lotId
          }
        }

      } else if (this.queryLastFIApproved) {
        params = {
          'parentDoc.division.identifier': this.contractModification.division.identifier,
          'parentDoc.division.parent.identifier': this.contractModification.division.parent.identifier
        }
        url = this.configuration.UNITPRICES_LAS_APPROVED_SERVICE_URL;
      } else if (this.queryFADJ) {
        params = {
          'parentDoc.division.identifier': this.contractModification.division.parent.identifier,
          'parentDoc.documentClass.identifier': '00065',
          'parentDoc.orderNumber': '0',
          'lot.lotId': this.lotes
        }
      }
      this.subscribe(
        this.plycaService.query<any>(
          url, params
        ).pipe(
          finalize(() => this.handleFinalize())
        ),
        results => {
          if (results && results.content) {
            if (this.tender) { this.queryFE = false; }
            if (this.contractModification) {
              this.queryLastFIApproved = false;
              this.queryFADJ = false;
            }

            this.elements = results.content.sort(
              (a, b) => {
                // Sort by group
                // If the first item has a higher number, move it down
                // If the first item has a lower number, move it up
                if (a.group > b.group) { return 1; }
                if (a.group < b.group) { return -1; }
                // If the group  is the same between both items, sort identifier
                // If the first item identifier comes first in the alphabet, move it up
                // Otherwise move it down
                if (a.identifier > b.identifier) { return 1; }
                if (a.identifier < b.identifier) { return -1; }
              }
            );
            this.elements.forEach(
              (up: UnitPriceDTO) =>
                up['lotsArray'] = this.lotsArray);
          } else {
            if (this.contractModification) {
              if (this.queryLastFIApproved) {
                this.queryLastFIApproved = false;
                this.queryFADJ = true;
              } else {
                this.queryFADJ = false;
              }
              this.loadDataPreviousDocument()
            }
          }
          this.filteredElements = [].concat(this.elements);
          this.loaded = true;
        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error)
        });
    }
  }

  private initializeFormConfig(): void {
    this.subscribe(this.createFormConfig1(), (form1: FormConfig) => {
      this.formConfig1 = form1;
      this.formConfig1.functions.push(
        { identifier: 'updateFilter', fn: this.updateFilter.bind(this) },
        { identifier: 'updateFilterTenderLot', fn: this.updateFilterTenderLot.bind(this) }
      );
    });
  }

  private handleFinalize() {
    if (this.updateTenderFilter) {
      this.getFEGroups();
      this.initializeFormConfig();
      this.loaded = true;
      this.updateTenderFilter = false;
    } else {
      this.loaded = true;
    }
    this.waitService.cancelWaiting();
  }


  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }


  private editableCalculateTAX(): boolean {
    if (this.procurementprojectLot && !this.procurementprojectAM) {
      // No se pueden editar, se hace de forma automatica
      if (this.calculateTAX) {
        return false;
      }
    }
    return true;

  }


  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    // config.fieldStyle = 'col-12 col-md-4';
    config.jsonField = name;
    if (name === 'tenderingPrice' || name === 'amountExcludingTaxes' || name === 'totalTaxes' || name === 'totalAmount') {
      config.type = 'CURRENCY';
      config.maxDecimals = this.PRECIOSUNITARIOS_NUMDECIMALES;
    } else if (name === 'amount') {
      config.type = 'INTEGER';
    } else if (name === 'taxType') {
      // Es necesario pasarle la fecha de alta del expediente al buscador de tipos de impuesto
      config.type = 'SEARCH';
      config.idBuscador = 'MASTERDATATAXTYPE_UNITPRICE';
      config.autoSearch = true;
      config.searchTitle = 'Tipos de IVA';
    } else if (name === 'description') {

      config.type = 'TEXT';
      config.maxlength = 3200;

    } else if (name === 'complementaryOne' || name === 'complementaryTwo'
    ) {
      config.type = 'TEXT';
      config.maxlength = 750;
    } else if (
      name === 'internalCode') {
      config.type = 'TEXT';
      config.maxlength = 40;
    } else if (
      name === 'internalCode' || name === 'group') {
      config.type = 'TEXT';
      config.maxlength = 100;
    } else
      if (name === 'lot') {

        config.type = 'DROPDOWN';
        config.dataConfig = new DataRetrieverConfig();
        config.dataConfig.jsonPath = 'lotsArray';
        config.parameters = [];
      }

    // Campos requeridos
    if (name === 'lot'
      || name === 'internalCode'
      || name === 'description'
      || name === 'taxType'
    ) {
      // config.required = 'true'
    }

    // Campos no editables
    if (name === 'tenderingPrice') {
      //  config.editable = false
    }

    if (name === 'totalTaxes' || name === 'totalAmount') {
      config.editable = this.editableCalculateTAX();
    }
    return config;
  }

  public setTaxTypes(model: any) {

    // Por cada tipo de condiciones especiales de la ejecución, se inserta un registro en la tabla de Condiciones Especiales de la Ejecución
    this.subscribe(this.plycaService.getMasterDataValues('TIPO_IMPUESTO', undefined, undefined, 'expansionSet:COMPLETE').pipe(
      tap(
        (data) => {
          if (data && data.content) {
            // Se filtran los tipos a mostrar y se ordenan por el campo orden
            let filteredTaxTypes = data.content
              .filter((taxType) => (taxType.properties.ACTIVO === 1))
              .sort(
                (a, b) =>
                  a.properties.ORDEN < b.properties.ORDEN
                    ? -1
                    : a.properties.ORDEN > b.properties.ORDEN
                      ? 1
                      : 0
              );
            if (filteredTaxTypes && filteredTaxTypes.length > 0) {
              this.taxTypes = filteredTaxTypes;
            }

          }
          (error: any) => this.plycaErrorHandler.showServerError(error);
        }

      )));
  }


  public getPercentaje(tax: MasterDataDTO): number {
    let percentage = 0;
    if (this.taxTypes && this.taxTypes.length > 0) {
      for (let taxtype of this.taxTypes) {
        if (tax.identifier === taxtype.identifier) {
          // Retrieve the 'PORCENTAJE' value from the properties map
          percentage = taxtype.properties['PORCENTAJE'];
          break;
        }
      }
    }
    // Return a default value if no matching tax type is found
    return percentage; // or any other appropriate default value
  }

  public calculateAutomaticTAX(element: any) {

    if (element) {
      let noTax = (element.taxType &&
        element.taxType.identifier == '0<>TIPO_IMPUESTO');

      if (element.taxType && element.taxType.identifier) {
        let percentage = this.getPercentaje(element.taxType);
        if (noTax) {
          element.totalTaxes = 0;

        } else {
          if (percentage != undefined && percentage != 0 && element.amountExcludingTaxes != undefined && element.amountExcludingTaxes !== null) {
            element.totalTaxes = ((element.amountExcludingTaxes * percentage) / 100);
          }
        }
      } else {// Si no se ha seleccionado ningún tipo de impuesto es neceario limpiar el valor
        element.totalTaxes = 0;
        element.totalAmount = 0;
      }

      if (element.totalTaxes) {
        element.totalAmount = (element.amountExcludingTaxes + element.totalTaxes);
      }
      else {
        element.totalAmount = element.amountExcludingTaxes;
      }
    }
  }

  // Se calcula el Total IVA de todas las filas
  public onChangeCalculateTAX(checked: any, elements: UnitPriceDTO[]): any {
    if (this.procurementprojectLot && !this.procurementprojectAM) {
      if (this.elements && this.elements.length > 0) {
        if (checked) {

          this.confirmationService.confirm({
            message: 'Se va a proceder a recalcular la cuantía del IVA y precio con IVA, modificando cualquier cálculo manual. ¿Está seguro/a de continuar?',
            acceptLabel: 'Aceptar',
            rejectVisible: true,
            accept: () => {

              if (this.elements && this.elements.length > 0) {
                // Iterar sobre la colección de elementos
                for (let element of this.elements) {
                  this.calculateAutomaticTAX(element);
                  //this.changeDetectorRef.detectChanges();
                }
              }
            }, reject: () => {
              console.log('NO SE IMPORTAN LAS EMPRESAS A INVITAR');
            }
          });
        }
      }
    }
  }

  public onAmountExcludingTaxesChange(evt: any, element: UnitPriceDTO): any {
    if (this.procurementprojectLot && !this.procurementprojectAM && this.calculateTAX) {
      // Si se acaba de añadir la fila
      this.calculateAutomaticTAX(element);
    }
  }


  public onTaxTypeChange(evt: any, element: UnitPriceDTO): any {
    if (this.procurementprojectLot && !this.procurementprojectAM && this.calculateTAX) {


      // Si se acaba de añadir la fila
      if (evt !== null) {
        if ((evt.oldValue == undefined || evt.oldValue == null) && (evt.newValue.identifier !== undefined && evt.newValue.identifier !== null)) {
          this.calculateAutomaticTAX(element);
        }

        // Si los valores son diferentes y distintos de nulos
        if (evt.oldValue !== undefined && evt.oldValue != null && evt.newValue.identifier !== undefined && evt.newValue.identifier !== null && evt.oldValue.identifier !== evt.newValue.identifier) {
          this.calculateAutomaticTAX(element);
        }
      }
    }
  }




  /*public valueBudgetTotalTax_UnitPrice(model: any) {
    if (model?._parent?.budget?.manualTaxCalculation == undefined || (model?._parent?.budget?.manualTaxCalculation != undefined && model?._parent?.budget?.manualTaxCalculation)) {
      // Exento de IVA
      let noTax = (model.taxType &&
        model.taxType.identifier == '0<>TIPO_IMPUESTO');

      if (model.taxType && model.taxType.identifier) {
        let taxType = model.taxType.identifer;
        if (model.taxType.properties != undefined) {
          let percentage = model.taxType.properties.PORCENTAJE;
          // Exento de IVA
          if (noTax) {
            model.totalTaxes = 0;
          } else {
            if (percentage != undefined && percentage != 0 && model.amountExcludingTaxes != undefined && model.amountExcludingTaxes !== null) {
              //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
              model.totalTaxes = ((model.amountExcludingTaxes * percentage) / 100);
            }
          }
        }
      } else {
        // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
        // model.budget.amountExcludingTaxes = 0;
        model.totalTaxes = 0;
        model.totalAmount = 0;
      }
    }
  }*/


  onRowEditInit(item: any, index: number) {
    this.editingMode = true;
    let cloned = lodash.cloneDeep(item);
    this.clonedElements[cloned.identifier] = { ...cloned };
  }

  onRowEditSave(item: UnitPriceDTO, index: number) {


    let requiredOK = true;
    if (this.procurementprojectLot && !this.procurementprojectAM) {
      if ((!item.description || item.description === '') ||
        (!item.amount || item.amount === 0) ||
        (!item.amountExcludingTaxes || item.amountExcludingTaxes == 0)) {
        requiredOK = false;
        this.uiService.showMessage('Es obligatorio cumplimentar los siguientes campos: "Descipción, Cantidad y Precio Unitario sin IVA"',
          this.translateService.instant('General.error'));
      }
    } else {
      if (!item.description || item.description === ''
        || (!item.taxType || !item.taxType.identifier)
        || (!item.amountExcludingTaxes || item.amountExcludingTaxes == 0)) {

        // this.onRowEditCancel(item, index);
        requiredOK = false;
        this.uiService.showMessage('Es obligatorio cumplimentar los siguientes campos: "Descipción, Precio Unitario sin IVA y Tipo IVA"',
          this.translateService.instant('General.error'));
      }
    }

    if (requiredOK) {
      if (item.amountExcludingTaxes) {
        if (this.procurementprojectLot && !this.procurementprojectAM && this.calculateTAX) {
          this.calculateAutomaticTAX(item);
        }
      }

      delete this.clonedElements[item.identifier];
      this.uiService.showSuccess(
        this.translateService.instant('General.msg.updateok'),
        this.translateService.instant('General.info'),
        'success'
      );

    }
    this.editingMode = false;
  }

  onRowEditCancel(item: UnitPriceDTO, index: number) {
    this.clearFilter();
    this.elements[index] = this.clonedElements[item.identifier];
    this.filteredElements = [].concat(this.elements);
    delete this.clonedElements[item.identifier];
    this.editingMode = false;
  }


  onRowDelete(item: UnitPriceDTO, index: number) {



    this.uiService.showConfirmMessage(
      {
        message: this.translateService.instant('Forms.table.deleteRow'),
        acceptLabel: this.translateService.instant('General.yes'),
        rejectLabel: this.translateService.instant('General.no'),
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.clearFilter();
          this.elements = this.elements.filter(it => it.identifier !== item.identifier);
          this.filteredElements = [].concat(this.elements);
          //this.changeDetectorRef.detectChanges();
        }
      });

  }

  public updateFilter(model: any) {
    if ((!model.description || model?.description === '')
      && (!model.code || model?.code === '')
      && (!model.group || model?.group === '')
    ) {
      this.filteredElements = [].concat(this.elements);
    } else {

      this.filteredElements = this.elements.filter((item: UnitPriceDTO) => {
        let valid =
          ((!model.description || model?.description === '' || model.description === undefined)
            || (item.description !== undefined && item.description.toLowerCase().indexOf(model.description.toLowerCase()) !== -1))
          &&
          ((!model.code || model?.code === '' || model.code === undefined) || (item.internalCode !== undefined && item.internalCode.toLowerCase().indexOf(model.code.toLowerCase()) !== -1))
          &&
          ((!model.group || model?.group === '' || model.group === undefined) || (item.group !== undefined && item.group.toLowerCase().indexOf(model.group.toLowerCase()) !== -1));


        return valid;
      }
      )
    }
  }

  public updateFilterTenderLot() {
    this.queryFE = false;
    this.updateTenderFilter = true;
    this.filterModel.description = '';
    this.filterModel.code = '';
    this.filterModel.group = '';

    this.selectedLot = this.filterModel.filterSelectedLot;

    // Aunque la oferta tenga mas de un lote, trabajamos de uno en uno.
    // La variable lotsArray, tiene el valor del lote seleccionado en el filtro.
    this.lotsArray = this.filterModel.filterListaLotes.filter(
      lote => lote.lotId === this.selectedLot.lotId
    );

    this.lotsArray = this.filterModel.filterListaLotes
      .filter(lote => lote.lotId === this.selectedLot.lotId)
      .map(lote => ({
        label: this.selectedLot.lotNumber + '-' + this.selectedLot.description,
        value: this.selectedLot
      }));

    this.updateFilter(this.filterModel);
    this.loadData();
  }




  getFEGroups() {
    this.waitService.startWaiting();
    this.loaded = false;

    let params;
    let apportionned = this.tender['project'].breakdownLot.apportioned === true;
    if (!apportionned || (apportionned && this.tender.tenderLots !== undefined && !(this.tender.tenderLots.length > 1))) {
      params = {
        'parentDoc.division.project.identifier': this.tender.division.project.identifier,
        'parentDoc.documentClass.identifier': '00002',
        'parentDoc.orderNumber': 0 + '',
        'lot.lotId': this.lotes
      }
    } else {
      // Hay mas de un lote
      params = {
        'parentDoc.division.project.identifier': this.tender.division.project.identifier,
        'parentDoc.documentClass.identifier': '00002',
        'parentDoc.orderNumber': 0 + '',
        'lot.lotId': this.selectedLot.lotId
      }
    }



    this.subscribe(
      this.plycaService.query<any>(
        this.configuration.UNITPRICES_SERVICE_URL, params
      ).pipe(
        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      items => {
        if (this.updateFilterTenderLot) {
          // limpiamos los grupos anteriores
          this.FEitems = [];
          this.groupsArray = [];
        }
        if (items && items.content) {
          this.FEitems = [...items.content];

          // Utilizamos un Set para almacenar los labels únicos
          const uniqueLabels = new Set<string>();

          items.content.map((i) => {
            return {
              label: i.group,
              value: i.group
            } as SelectItem;
          }).forEach((item: SelectItem) => {
            if (!uniqueLabels.has(item.label)) {
              uniqueLabels.add(item.label);
              this.groupsArray.push(item);
            }
          });

        } else {
          this.groupsArray = [];
        }

      },
      error => {
        this.plycaErrorHandler.showServerError(error)
      });


  }
  calculatePercentage(importeSinIva: number, porcentajeBaja: number) {

    /*
    double importeSIVABaja = (importeSinIva * porcentajeBaja.doubleValue()) / 100;
      importeSIVABaja =
      new Double(new java.math.BigDecimal(importeSIVABaja)
      .setScale(decimales, java.math.BigDecimal.ROUND_HALF_EVEN).toString()).doubleValue();
        importeSinIva = importeSinIva - importeSIVABaja;
    */
    let result = 0;

    let importeSIVABaja = (importeSinIva * porcentajeBaja) / 100
    result = importeSinIva - importeSIVABaja;
    return result;

  }


  private parameters2string(action: ActionDTO, target: any): string {
    let parametersAsString = '';
    // let targetSet = false;
    if (action.parameters) {
      parametersAsString = action.parameters
        .filter((param) => param.value && param.name !== 'TARGET')
        .map((param) => {
          if (param.value && param.value[0] && param.value[0].identifier) {
            return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value[0].identifier)}`;
          } else if (param.value instanceof Array) {
            let valTemp = '';
            param.value.forEach(v => {
              valTemp += v + ',';
            });
            valTemp = valTemp.substring(0, valTemp.length - 1);
            return `${encodeURIComponent(param.name)}=${encodeURIComponent(valTemp)}`;
          } else {
            if (param.value.identifier) {
              return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value.identifier)}`;
            } else {
              return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value)}`;
            }
          }
        })
        .join('&');
    }

    // establecer target
    if (parametersAsString !== '') {
      parametersAsString += '&';
    }

    let _target = target;
    if (_target) {
      parametersAsString += 'TARGET=' + target ? target.identifier : null;
    }

    return parametersAsString;
  }

  public verify() {
    if (this.procurementprojectLot) {

      let errorMsg = '<br><ul>';

      // 1. Es obligatorio introducir al menos un registro
      if (this.elements == null || this.elements == undefined || (this.elements && this.elements.length == 0)) {
        errorMsg += '<li>' + 'Debe introducir al menos un registro en la tabla de "Precios Unitarios"' + '</li>';
      }

      // 2. Códigos duplicados
      if (this.elements && this.elements.length > 1) {
        // Crear un conjunto para almacenar códigos internos únicos
        let codigosUnicos = new Set();

        // Iterar sobre la colección de elementos
        for (let element of this.elements) {
          // Verificar si el código interno ya está en el conjunto
          if (codigosUnicos.has(element.internalCode)) {
            // Mostrar una ventana con el código duplicado
            errorMsg += '<li>' + 'El campo "Cod. Interno" de la tabla de "Precios Unitarios" no puede estar duplicado a nivel de expediente: ' + element.internalCode + '</li>';
            break; // Terminar la función después de encontrar el primer duplicado
          } else {
            // Agregar el código interno al conjunto si no está duplicado
            codigosUnicos.add(element.internalCode);
          }
        }
      }

      // 3. Columnas obligatorias
      if (this.elements && this.elements.length > 0) {
        let registrosSinDescription = 0;
        let registrosPrecioSinIva = 0;
        let registrosSinTaxType = 0;

        for (let element of this.elements) {
          if (!element.amountExcludingTaxes) {
            registrosPrecioSinIva++;
          }
          if (!element.description) {
            registrosSinDescription++;
          }
          if (!element.taxType) {
            registrosSinTaxType++;
          }
        }

        if (registrosSinDescription > 0) {
          errorMsg += '<li>' + 'En la tabla de "Precios Unitarios" es obligatorio introducir, la "Descripción", núm. de registros afectados: ' + registrosSinDescription + '</li>'
        }
        if (registrosSinTaxType > 0) {
          errorMsg += '<li>' + 'En la tabla de "Precios Unitarios" es obligatorio introducir, el "Tipo de IVA", núm. de registros afectados: ' + registrosSinTaxType + '</li>'
        }
        if (registrosPrecioSinIva > 0) {
          errorMsg += '<li>' + 'En la tabla de "Precios Unitarios" es obligatorio introducir, la "Precio Unitario sin IVA", núm. de registros afectados: ' + registrosSinDescription + '</li>'
        }

      }

      errorMsg += '</ul>'

      if (errorMsg.includes('<li>')) {
        this.uiService.showMessage(errorMsg,
          this.translateService.instant('General.error'));
      }

    }

  }

  public showValidationResult(validation: ValidationResultDTO): void {
    this.showValidationInfo = true;
    this.validationResult = validation;
  }

  public showValidation(): void {
    this.showValidationInfo = true;
    let validation = new ValidationResultDTO();
    validation.result = ResultTypeDTO.WARNING;
    validation.errors = [];
    let error = new ValidationExecutionDTO();
    error.message = 'PRUEBA INES DE ERROR';
    validation.errors.push(error);
    this.showValidationResult(validation);
  }


  // METODOS DE ERROR
  public closeValidationResult(): void {
    this.showValidationInfo = false;
    this.validationResult = undefined;
  }

  public enabledHeaderButtons() {
    if (this.tender) {
      let apportioned = this.tender['project'].breakdownLot.apportioned === true;
      return !apportioned
        || (apportioned && this.filterModel?.filterListaLotes.length == 1)
        || (apportioned && this.filterModel.filterSelectedLot !== undefined && this.filterModel.filterSelectedLot !== null)
    } else {
      return true;
    }
  }


}
